import { useTranslation } from 'react-i18next';

export function NoPaymentNote() {
  const { t } = useTranslation();
  return (
    <div className="flex items-start gap-3 rounded-2xl bg-gradient-to-br from-cream to-oud-50 border border-gold-soft/50 p-4 shadow-soft">
      <div className="flex-none w-10 h-10 rounded-full bg-gradient-to-br from-gold to-oud-700 text-sand flex items-center justify-center shadow-soft">
        <ShieldIcon className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0 pt-0.5">
        <h3 className="text-sm font-black text-oud-900">{t('cart.soft_note_title')}</h3>
        <p className="text-[12.5px] text-oud-700 leading-relaxed mt-0.5">
          {t('cart.soft_note_body')}
        </p>
      </div>
    </div>
  );
}

function ShieldIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      <path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6l8-3Z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}
